import { objectToMap } from '../common/utils';

const textToCthGroupObject = {
	'KBo 32.14_test': 'CTH 0',
	'KUB 29.41': 'CTH 285',
	'KUB 29.44+': 'CTH 285',
	'KUB 29.55+': 'CTH 285',
	'Bo 5700': 'CTH 341',
	'Gurney 5': 'CTH 341',
	'HT 10': 'CTH 341',
	'KBo 10.47c': 'CTH 341',
	'KBo 10.48': 'CTH 341',
	'KBo 10.49': 'CTH 341',
	'KBo 19.114': 'CTH 341',
	'KBo 19.115': 'CTH 341',
	'KBo 19.116': 'CTH 341',
	'KBo 19.117': 'CTH 341',
	'KBo 19.118': 'CTH 341',
	'KBo 19.119': 'CTH 341',
	'KBo 19.120': 'CTH 341',
	'KBo 19.122': 'CTH 341',
	'KBo 22.91': 'CTH 341',
	'KBo 22.92': 'CTH 341',
	'KBo 22.93': 'CTH 341',
	'KBo 22.94': 'CTH 341',
	'KBo 26.101': 'CTH 341',
	'KBo 26.102': 'CTH 341',
	'KBo 54.2': 'CTH 341',
	'KBo 6.1': 'CTH 341',
	'KBo 60.14': 'CTH 341',
	'KUB 17.3': 'CTH 341',
	'KUB 23.9': 'CTH 341',
	'KUB 33.124': 'CTH 341',
	'KUB 36.65': 'CTH 341',
	'KUB 36.72': 'CTH 341',
	'KUB 36.73': 'CTH 341',
	'KUB 60.14': 'CTH 341',
	'KUB 8.54': 'CTH 341',
	'KUB 8.55': 'CTH 341',
	'KUB 8.58': 'CTH 341',
	'KUB 8.59': 'CTH 341',
	'KUB 8.62': 'CTH 341',
	'HFAC 104': 'CTH 341',
	'KBo 32.129': 'CTH 341',
	'KBo 32.131+': 'CTH 341',
	'KBo 32.132': 'CTH 341',
	'KBo 32.133': 'CTH 341',
	'KBo 33.10+': 'CTH 341.II',
	'KBo 45.224': 'CTH 341',
	'KBo 51.228+': 'CTH 341.II',
	'KBo 59.245': 'CTH 341',
	'KBo 60.327': 'CTH 341',
	'KBo 8.144+': 'CTH 341.II',
	'KUB 33.123': 'CTH 341',
	'KUB 37.128': 'CTH 341',
	'KUB 4.12': 'CTH 341',
	'KUB 47.10': 'CTH 341.II',
	'KUB 47.15': 'CTH 341.II',
	'KUB 47.16': 'CTH 341.II',
	'TC-4F05h': 'CTH 341.II',
	'KBo 26.58': 'CTH 345',
	'KBo 26.59': 'CTH 345',
	'KBo 26.60': 'CTH 345',
	'KBo 26.61': 'CTH 345',
	'KBo 26.62': 'CTH 345',
	'KBo 26.63': 'CTH 345',
	'KBo 26.64': 'CTH 345',
	'KBo 26.65': 'CTH 345',
	'KBo 26.66': 'CTH 345',
	'KBo 26.67': 'CTH 345',
	'KBo 26.68': 'CTH 345',
	'KBo 26.69': 'CTH 345',
	'KBo 26.96': 'CTH 345',
	'KBo 26.97': 'CTH 345',
	'KBo 26.98': 'CTH 345',
	'KBo 26.99': 'CTH 345',
	'KBo 58.4': 'CTH 345',
	'KUB 33.107': 'CTH 345',
	'KUB 33.92': 'CTH 345',
	'KUB 33.98+': 'CTH 345',
	'KUB 33.98': 'CTH 345',
	'KUB 36.13': 'CTH 345',
	'KUB 36.15': 'CTH 345',
	'ABoT 2.293': 'CTH 345',
	'CHDS 6.179': 'CTH 345',
	'KBo 19.125': 'CTH 345.II',
	'KBo 33.61a+': 'CTH 345.II',
	'KBo 57.171': 'CTH 345',
	'KUB 45.61': 'CTH 345.II',
	'KUB 45.64+': 'CTH 345.II',
	'KUB 45.82': 'CTH 345.II',
	'KBo 19.121': 'CTH 346',
	'KBo 22.84': 'CTH 346',
	'KBo 26.100': 'CTH 346',
	'KBo 26.105': 'CTH 346',
	'KBo 26.106': 'CTH 346',
	'KBo 26.108': 'CTH 346',
	'KBo 26.110': 'CTH 346',
	'KBo 26.113': 'CTH 346',
	'KBo 26.88': 'CTH 346',
	'KBo 26.89': 'CTH 346',
	'KBo 26.90': 'CTH 346',
	'KBo 26.91': 'CTH 346',
	'KBo 26.92': 'CTH 346',
	'KBo 26.93': 'CTH 346',
	'KBo 26.95': 'CTH 346',
	'KUB 33.105': 'CTH 346',
	'KUB 33.117': 'CTH 346',
	'KUB 33.118': 'CTH 346',
	'KUB 33.99': 'CTH 346',
	'KUB 36.20': 'CTH 346',
	'KUB 36.25': 'CTH 346',
	'KUB 36.30': 'CTH 346',
	'DAAM 1.14': 'CTH 346.II',
	'KBo 27.216': 'CTH 346.II',
	'KBo 54.4': 'CTH 346.II',
	'KUB 45.63': 'CTH 346.II',
	'UK09.E.2': 'CTH 346',
	'VBoT 59': 'CTH 346.II',
	'IBoT 2.135': 'CTH 348',
	'KBo 19.109a': 'CTH 348',
	'KBo 19.110': 'CTH 348',
	'KBo 19.111': 'CTH 348',
	'KBo 19.112': 'CTH 348',
	'KBo 19.112A': 'CTH 348',
	'KBo 19.113': 'CTH 348',
	'KBo 22.51': 'CTH 348',
	'KBo 26.109': 'CTH 348',
	'KBo 26.112': 'CTH 348',
	'KBo 26.117': 'CTH 348',
	'KBo 26.142': 'CTH 348',
	'KBo 26.70': 'CTH 348',
	'KBo 26.72': 'CTH 348',
	'KBo 26.73': 'CTH 348',
	'KBo 26.74': 'CTH 348',
	'KBo 26.75': 'CTH 348',
	'KBo 26.76': 'CTH 348',
	'KBo 26.77': 'CTH 348',
	'KBo 26.78': 'CTH 348',
	'KBo 26.79': 'CTH 348',
	'KBo 26.80': 'CTH 348',
	'KBo 26.81': 'CTH 348',
	'KBo 26.82': 'CTH 348',
	'KBo 26.83': 'CTH 348',
	'KBo 26.94': 'CTH 348',
	'KBo 56.6': 'CTH 348',
	'KBo 57.230+': 'CTH 348',
	'KUB 33.103': 'CTH 348',
	'KUB 33.110': 'CTH 348',
	'KUB 33.116': 'CTH 348',
	'KUB 33.122': 'CTH 348',
	'KUB 33.85': 'CTH 348',
	'KUB 33.88': 'CTH 348',
	'KUB 33.90': 'CTH 348',
	'KUB 36.16': 'CTH 348',
	'KUB 36.56': 'CTH 348',
	'KUB 36.57': 'CTH 348',
	'KUB 36.58': 'CTH 348',
	'KUB 43.64': 'CTH 348',
	'KUB 43.65': 'CTH 348',
	'KUB 8.64': 'CTH 348',
	'KUB 8.67': 'CTH 348',
	'ABoT 2.17': 'CTH 348',
	'KBo 12.80+': 'CTH 348.II',
	'KBo 53.74': 'CTH 348',
	'KBo 65.26': 'CTH 348',
	'KUB 47.14': 'CTH 348.II',
	'KBo 22.89': 'CTH 361',
	'KBo 57.15': 'CTH 361',
	'KUB 17.1': 'CTH 361',
	'KUB 36.63': 'CTH 361',
	'VSNF 12.131': 'CTH 361',
	'ABoT 2.18': 'CTH 361.II',
	'FHL 179': 'CTH 361.II',
	'KBo 27.219+': 'CTH 361.II',
	'KBo 35.43': 'CTH 361.II',
	'KBo 53.2': 'CTH 361.II',
	'KBo 57.287': 'CTH 361',
	'KBo 59.226': 'CTH 361.II',
	'KBo 71.80': 'CTH 361.II',
	'KUB 27.40+': 'CTH 361.II',
	'KUB 47.2': 'CTH 361.II',
	'KUB 47.3': 'CTH 361.II',
	'KUB 47.4': 'CTH 361.II',
	'KUB 47.5+': 'CTH 361.II',
	'KUB 47.6': 'CTH 361.II',
	'KUB 47.8': 'CTH 361.II',
	'KUB 52.114+': 'CTH 361.II',
	'KUB 52.115': 'CTH 361.II',
	'336_u': 'CTH 370',
	'461_u': 'CTH 370',
	'677_u': 'CTH 370',
	'832_u': 'CTH 370',
	'849_u': 'CTH 370',
	'888_z': 'CTH 370',
	'959_u': 'CTH 370',
	'Bo 1398': 'CTH 370',
	'Bo 2896': 'CTH 370',
	'Bo 3410': 'CTH 370',
	'Bo 3440': 'CTH 370',
	'Bo 3530': 'CTH 370',
	'Bo 3867': 'CTH 370',
	'Bo 4430': 'CTH 370',
	'Bo 4626': 'CTH 370',
	'Bo 5167': 'CTH 370',
	'Bo 5863': 'CTH 370',
	'Bo 6660': 'CTH 370',
	'Bo 69_589': 'CTH 370',
	'Bo 7241': 'CTH 370',
	'Bo 7273': 'CTH 370',
	'Bo 7627': 'CTH 370',
	'Bo 7666': 'CTH 370',
	'Bo 8278': 'CTH 370',
	'Bo 9721': 'CTH 370',
	'FHL 146': 'CTH 370',
	'HT 16': 'CTH 370',
	'Hobbit': 'CTH 370',
	'IBoT 3.85': 'CTH 370',
	'KBo 12.81': 'CTH 370',
	'KBo 12.88': 'CTH 370',
	'KBo 20.59': 'CTH 370',
	'KBo 22.72': 'CTH 370',
	'KBo 22.87': 'CTH 370',
	'KBo 25.25': 'CTH 370',
	'KBo 26.111': 'CTH 370',
	'KBo 26.114': 'CTH 370',
	'KBo 26.115': 'CTH 370',
	'KBo 26.116': 'CTH 370',
	'KBo 26.119': 'CTH 370',
	'KBo 26.120': 'CTH 370',
	'KBo 26.122': 'CTH 370',
	'KBo 26.129': 'CTH 370',
	'KBo 26.137': 'CTH 370',
	'KBo 26.138': 'CTH 370',
	'KBo 26.140': 'CTH 370',
	'KBo 26.141': 'CTH 370',
	'KBo 26.144': 'CTH 370',
	'KBo 26.87': 'CTH 370',
	'KBo 27.15': 'CTH 370',
	'KBo 27.32': 'CTH 370',
	'KBo 31.79': 'CTH 370',
	'KBo 32.108': 'CTH 370',
	'KBo 34.25': 'CTH 370',
	'KBo 34.29': 'CTH 370',
	'KBo 34.40': 'CTH 370',
	'KBo 38.163': 'CTH 370',
	'KBo 39.255': 'CTH 370',
	'KBo 40.19': 'CTH 370',
	'KBo 41.62': 'CTH 370',
	'KBo 42.74': 'CTH 370',
	'KBo 48.1': 'CTH 370',
	'KBo 49.36': 'CTH 370',
	'KBo 53.6': 'CTH 370',
	'KBo 53.7': 'CTH 370',
	'KBo 57.16': 'CTH 370',
	'KBo 57.303': 'CTH 370',
	'KBo 58.265': 'CTH 370',
	'KBo 60.15': 'CTH 370',
	'KBo 60.16': 'CTH 370',
	'KBo 60.336': 'CTH 370',
	'KBo 60.340': 'CTH 370',
	'KBo 60.46': 'CTH 370',
	'KBo 8.73': 'CTH 370',
	'KUB 33.43': 'CTH 370',
	'KUB 34.50': 'CTH 370',
	'KUB 34.51': 'CTH 370',
	'KUB 34.53': 'CTH 370',
	'KUB 34.63': 'CTH 370',
	'KUB 36.22': 'CTH 370',
	'KUB 36.23': 'CTH 370',
	'KUB 36.29': 'CTH 370',
	'KUB 36.4': 'CTH 370',
	'KUB 36.42': 'CTH 370',
	'KUB 36.43': 'CTH 370',
	'KUB 36.47': 'CTH 370',
	'KUB 36.49': 'CTH 370',
	'KUB 36.52': 'CTH 370',
	'KUB 36.53': 'CTH 370',
	'KUB 43.36': 'CTH 370',
	'KUB 56.17': 'CTH 370',
	'KUB 60.109': 'CTH 370',
	'Privat 41': 'CTH 370',
	'Privat 58': 'CTH 370',
	'VSNF 12.118': 'CTH 370',
	'VSNF 12.99': 'CTH 370',
	'ABoT 2.20': 'CTH 370',
	'CHDS 3.140': 'CTH 370',
	'CHDS 4.75': 'CTH 370',
	'KBo 19.147': 'CTH 370',
	'KBo 22.163': 'CTH 370',
	'KBo 23.25': 'CTH 370',
	'KBo 26.139': 'CTH 370',
	'KBo 26.143': 'CTH 370',
	'KBo 27.114+': 'CTH 370',
	'KBo 27.172': 'CTH 370',
	'KBo 27.188': 'CTH 370',
	'KBo 31.92': 'CTH 370',
	'KBo 33.62': 'CTH 370',
	'KBo 34.29+': 'CTH 370',
	'KBo 35.46': 'CTH 370',
	'KBo 35.47': 'CTH 370',
	'KBo 35.52+': 'CTH 370',
	'KBo 35.62': 'CTH 370',
	'KBo 40.102': 'CTH 370',
	'KBo 47.311': 'CTH 370',
	'KBo 51.12': 'CTH 370',
	'KBo 51.232': 'CTH 370',
	'KBo 52.224': 'CTH 370',
	'KBo 53.229': 'CTH 370',
	'KBo 53.232': 'CTH 370',
	'KBo 53.233': 'CTH 370',
	'KBo 53.280': 'CTH 370',
	'KBo 56.2': 'CTH 370',
	'KBo 60.232': 'CTH 370',
	'KBo 62.8': 'CTH 370',
	'KBo 64.195': 'CTH 370',
	'KBo 64.5': 'CTH 370',
	'KBo 64.6': 'CTH 370',
	'KBo 68.17': 'CTH 370',
	'KUB 45.81': 'CTH 370',
	'KUB 47.13': 'CTH 370',
	'KUB 47.18': 'CTH 370',
	'KUB 47.21': 'CTH 370',
	'KUB 47.56': 'CTH 370',
	'KUB 52.110': 'CTH 370',
	'KBo 27.108+': 'CTH 392',
	'ABoT 1.46': 'CTH 449',
	'ABoT 2.32': 'CTH 449',
	'Bo 6166+': 'CTH 449',
	'CHDS 3.87': 'CTH 449',
	'KBo 12.137': 'CTH 449',
	'KBo 14.100+': 'CTH 449',
	'KBo 17.94': 'CTH 449',
	'KBo 17.95': 'CTH 449',
	'KBo 17.96': 'CTH 449',
	'KBo 21.13': 'CTH 449',
	'KBo 35.193': 'CTH 449',
	'KBo 35.194': 'CTH 449',
	'KBo 46.8': 'CTH 449',
	'KBo 53.43': 'CTH 449',
	'KBo 55.52': 'CTH 449',
	'KUB 39.100': 'CTH 449',
	'KUB 39.101': 'CTH 449',
	'KUB 39.57': 'CTH 449',
	'KUB 39.99+': 'CTH 449',
	'KUB 46.36': 'CTH 449',
	'KUB 58.85': 'CTH 449',
	'VBoT 27': 'CTH 449',
	'CHDS 4.62': 'CTH 449',
	'CHDS 6.14': 'CTH 449',
	'CHDS 6.97': 'CTH 449',
	'KBo 65.28': 'CTH 449',
	'KUB 7.4+': 'CTH 449',
	'KBo 22.136': 'CTH 471',
	'KBo 34.78+': 'CTH 471',
	'KBo 5.2': 'CTH 471',
	'KBo 61.47': 'CTH 471',
	'KUB 45.12': 'CTH 471',
	'Bo 7776': 'CTH 485',
	'IBoT 3.148': 'CTH 485',
	'KBo 35.202': 'CTH 485',
	'KBo 35.203': 'CTH 485',
	'KBo 41.45': 'CTH 485',
	'KBo 43.228+': 'CTH 485',
	'KBo 52.84': 'CTH 485',
	'KBo 53.85': 'CTH 485',
	'KUB 15.37': 'CTH 485',
	'KUB 32.50': 'CTH 485',
	'KUB 47.90+': 'CTH 485',
	'KUB 7.50': 'CTH 485',
	'KBo 58.36': 'CTH 485',
	'KBo 60.64': 'CTH 485',
	'KBo 64.29': 'CTH 485',
	'KUB 58.73': 'CTH 485',
	'CHDS 2.114': 'CTH 490',
	'IBoT 2.116': 'CTH 490',
	'IBoT 2.47': 'CTH 490',
	'IBoT 4.142': 'CTH 490',
	'IBoT 4.27': 'CTH 490',
	'KBo 24.63+': 'CTH 490',
	'KBo 27.128': 'CTH 490',
	'KBo 27.140+': 'CTH 490',
	'KBo 27.147': 'CTH 490',
	'KBo 27.154+': 'CTH 490',
	'KBo 27.159+': 'CTH 490',
	'KBo 33.126': 'CTH 490',
	'KBo 33.200+': 'CTH 490',
	'KBo 33.37+': 'CTH 490',
	'KBo 33.38': 'CTH 490',
	'KBo 35.101+': 'CTH 490',
	'KBo 35.102': 'CTH 490',
	'KBo 35.103': 'CTH 490',
	'KBo 35.104': 'CTH 490',
	'KBo 35.106': 'CTH 490',
	'KBo 35.107+': 'CTH 490',
	'KBo 35.185': 'CTH 490',
	'KBo 44.95': 'CTH 490',
	'KBo 48.195': 'CTH 490',
	'KBo 55.161': 'CTH 490',
	'KBo 55.73': 'CTH 490',
	'KBo 57.109': 'CTH 490',
	'KBo 61.199': 'CTH 490',
	'KBo 61.77': 'CTH 490',
	'KBo 64.30': 'CTH 490',
	'KBo 67.130': 'CTH 490',
	'KBo 69.283': 'CTH 490',
	'KBo 69.291': 'CTH 490',
	'KBo 69.85': 'CTH 490',
	'KUB 12.51': 'CTH 490',
	'KUB 42.99': 'CTH 490',
	'KUB 44.54+': 'CTH 490',
	'KUB 45.24': 'CTH 490',
	'KUB 47.35': 'CTH 490',
	'KUB 47.51': 'CTH 490',
	'KUB 48.70': 'CTH 490',
	'KUB 52.108': 'CTH 490',
	'KUB 59.74': 'CTH 490',
	'KUB 59.75+': 'CTH 490',
	'KUB 60.158': 'CTH 490',
	'KUB 60.159': 'CTH 490',
	'KUB 7.37': 'CTH 490',
	'KBo 35.195': 'CTH 494',
	'KBo 38.199': 'CTH 494',
	'KBo 46.77': 'CTH 494',
	'KBo 47.207': 'CTH 494',
	'KBo 60.82': 'CTH 494',
	'KBo 40.185': 'CTH 494',
	'KBo 40.27+': 'CTH 494',
	'KUB 35.127': 'CTH 494',
	'KUB 45.47+': 'CTH 494',
	'KBo 71.187': 'CTH 500',
	'IBoT 2.55': 'CTH 615',
	'IBoT 4.28+': 'CTH 615',
	'KBo 11.20': 'CTH 615',
	'KBo 30.61': 'CTH 615',
	'KBo 35.229+': 'CTH 615',
	'KBo 38.286': 'CTH 615',
	'KBo 46.102+': 'CTH 615',
	'KBo 48.121': 'CTH 615',
	'KBo 51.127+': 'CTH 615',
	'KBo 51.128': 'CTH 615',
	'KBo 57.141': 'CTH 615',
	'KBo 57.142': 'CTH 615',
	'KBo 57.143': 'CTH 615',
	'KBo 58.110+': 'CTH 615',
	'KBo 63.72': 'CTH 615',
	'KBo 64.344': 'CTH 615',
	'KBo 64.345': 'CTH 615',
	'KUB 41.13': 'CTH 615',
	'KUB 45.35': 'CTH 615',
	'KUB 45.36': 'CTH 615',
	'KUB 45.37': 'CTH 615',
	'KUB 45.38': 'CTH 615',
	'KUB 45.39': 'CTH 615',
	'KUB 47.70': 'CTH 615',
	'KUB 51.86': 'CTH 615',
	'UK 14.E.43': 'CTH 615',
	'VBoT 50': 'CTH 615',
	'ABoT 2.114+': 'CTH 628',
	'ABoT 2.140': 'CTH 628',
	'AMUM 1996': 'CTH 628',
	'Bo 7837': 'CTH 628',
	'Bo 7850': 'CTH 628',
	'Bo 7860': 'CTH 628',
	'Bo 7909': 'CTH 628',
	'Bo 7957': 'CTH 628',
	'CHDS 4.10': 'CTH 628',
	'CHDS 4.128': 'CTH 628',
	'CHDS 4.14+': 'CTH 628',
	'CHDS 4.161': 'CTH 628',
	'CHDS 4.18': 'CTH 628',
	'CHDS 4.200': 'CTH 628',
	'CHDS 4.206': 'CTH 628',
	'CHDS 4.209': 'CTH 628',
	'CHDS 4.226': 'CTH 628',
	'CHDS 4.24': 'CTH 628',
	'CHDS 4.37': 'CTH 628',
	'CHDS 4.42': 'CTH 628',
	'CHDS 4.45': 'CTH 628',
	'CHDS 4.47': 'CTH 628',
	'CHDS 5.109': 'CTH 628',
	'CHDS 5.124': 'CTH 628',
	'CHDS 5.125+': 'CTH 628',
	'CHDS 5.135': 'CTH 628',
	'CHDS 5.163': 'CTH 628',
	'CHDS 5.166+': 'CTH 628',
	'CHDS 5.177': 'CTH 628',
	'CHDS 5.28': 'CTH 628',
	'CHDS 5.83': 'CTH 628',
	'CHDS 6.187': 'CTH 628',
	'DAAM 1.16': 'CTH 628',
	'DAAM 1.17': 'CTH 628',
	'DAAM 1.20': 'CTH 628',
	'DAAM 1.5': 'CTH 628',
	'DAAM 1.80': 'CTH 628',
	'DBH 46_2.141': 'CTH 628',
	'DBH 54.32': 'CTH 628',
	'FHL 33': 'CTH 628',
	'HFAC 41': 'CTH 628',
	'HFAC 55': 'CTH 628',
	'HT 24+': 'CTH 628',
	'IBoT 1.24': 'CTH 628',
	'IBoT 2.45': 'CTH 628',
	'IBoT 2.49': 'CTH 628',
	'IBoT 2.52': 'CTH 628',
	'IBoT 2.56': 'CTH 628',
	'IBoT 2.60': 'CTH 628',
	'IBoT 2.85+': 'CTH 628',
	'IBoT 3.21': 'CTH 628',
	'IBoT 3.48': 'CTH 628',
	'IBoT 3.53': 'CTH 628',
	'IBoT 3.55': 'CTH 628',
	'IBoT 4.122': 'CTH 628',
	'IBoT 4.143': 'CTH 628',
	'IBoT 4.150': 'CTH 628',
	'IBoT 4.281': 'CTH 628',
	'IBoT 4.83': 'CTH 628',
	'IBoT 4.84': 'CTH 628',
	'IBoT 4.87': 'CTH 628',
	'IBoT 4.88+': 'CTH 628',
	'IBoT 4.90': 'CTH 628',
	'IBoT 4.91': 'CTH 628',
	'KBo 11.24+': 'CTH 628',
	'KBo 13.168': 'CTH 628',
	'KBo 13.189': 'CTH 628',
	'KBo 14.24': 'CTH 628',
	'KBo 15.37': 'CTH 628',
	'KBo 15.49+': 'CTH 628',
	'KBo 15.51': 'CTH 628',
	'KBo 15.52+': 'CTH 628',
	'KBo 15.57': 'CTH 628',
	'KBo 15.58': 'CTH 628',
	'KBo 15.60': 'CTH 628',
	'KBo 15.61': 'CTH 628',
	'KBo 15.64+': 'CTH 628',
	'KBo 15.65+': 'CTH 628',
	'KBo 15.67+': 'CTH 628',
	'KBo 16.96': 'CTH 628',
	'KBo 17.98': 'CTH 628',
	'KBo 2.33': 'CTH 628',
	'KBo 20.106+': 'CTH 628',
	'KBo 20.114+': 'CTH 628',
	'KBo 20.115': 'CTH 628',
	'KBo 20.120': 'CTH 628',
	'KBo 20.121': 'CTH 628',
	'KBo 20.60': 'CTH 628',
	'KBo 21.38': 'CTH 628',
	'KBo 22.187': 'CTH 628',
	'KBo 22.245': 'CTH 628',
	'KBo 23.11': 'CTH 628',
	'KBo 23.20+': 'CTH 628',
	'KBo 23.83': 'CTH 628',
	'KBo 23.85': 'CTH 628',
	'KBo 24.13': 'CTH 628',
	'KBo 24.40': 'CTH 628',
	'KBo 24.75': 'CTH 628',
	'KBo 24.76+': 'CTH 628',
	'KBo 24.78': 'CTH 628',
	'KBo 24.99': 'CTH 628',
	'KBo 25.163+': 'CTH 628',
	'KBo 27.149': 'CTH 628',
	'KBo 27.163': 'CTH 628',
	'KBo 27.194+': 'CTH 628',
	'KBo 27.198': 'CTH 628',
	'KBo 30.133': 'CTH 628',
	'KBo 31.112': 'CTH 628',
	'KBo 31.156': 'CTH 628',
	'KBo 31.158': 'CTH 628',
	'KBo 31.173': 'CTH 628',
	'KBo 31.174': 'CTH 628',
	'KBo 31.175': 'CTH 628',
	'KBo 31.176': 'CTH 628',
	'KBo 31.177': 'CTH 628',
	'KBo 31.179': 'CTH 628',
	'KBo 31.180+': 'CTH 628',
	'KBo 31.181+': 'CTH 628',
	'KBo 31.182+': 'CTH 628',
	'KBo 33.121': 'CTH 628',
	'KBo 33.131': 'CTH 628',
	'KBo 33.144': 'CTH 628',
	'KBo 33.160+': 'CTH 628',
	'KBo 33.168+': 'CTH 628',
	'KBo 33.172': 'CTH 628',
	'KBo 33.174': 'CTH 628',
	'KBo 33.175+': 'CTH 628',
	'KBo 33.176': 'CTH 628',
	'KBo 33.177': 'CTH 628',
	'KBo 33.178': 'CTH 628',
	'KBo 33.179': 'CTH 628',
	'KBo 33.180': 'CTH 628',
	'KBo 33.181': 'CTH 628',
	'KBo 33.184': 'CTH 628',
	'KBo 33.186': 'CTH 628',
	'KBo 33.187+': 'CTH 628',
	'KBo 33.188': 'CTH 628',
	'KBo 33.191+': 'CTH 628',
	'KBo 33.193': 'CTH 628',
	'KBo 33.194+': 'CTH 628',
	'KBo 33.195': 'CTH 628',
	'KBo 33.215+': 'CTH 628',
	'KBo 34.100': 'CTH 628',
	'KBo 34.180': 'CTH 628',
	'KBo 34.181+': 'CTH 628',
	'KBo 34.235': 'CTH 628',
	'KBo 34.249': 'CTH 628',
	'KBo 35.167': 'CTH 628',
	'KBo 35.232+': 'CTH 628',
	'KBo 35.252': 'CTH 628',
	'KBo 35.254': 'CTH 628',
	'KBo 35.255': 'CTH 628',
	'KBo 35.259': 'CTH 628',
	'KBo 35.260+': 'CTH 628',
	'KBo 35.261': 'CTH 628',
	'KBo 35.262+': 'CTH 628',
	'KBo 35.264': 'CTH 628',
	'KBo 38.144': 'CTH 628',
	'KBo 38.15': 'CTH 628',
	'KBo 38.22': 'CTH 628',
	'KBo 38.23': 'CTH 628',
	'KBo 38.269': 'CTH 628',
	'KBo 38.274': 'CTH 628',
	'KBo 39.21': 'CTH 628',
	'KBo 39.269': 'CTH 628',
	'KBo 39.73': 'CTH 628',
	'KBo 40.172': 'CTH 628',
	'KBo 40.347': 'CTH 628',
	'KBo 40.353': 'CTH 628',
	'KBo 40.63': 'CTH 628',
	'KBo 40.64': 'CTH 628',
	'KBo 40.65': 'CTH 628',
	'KBo 41.55': 'CTH 628',
	'KBo 41.56': 'CTH 628',
	'KBo 41.65': 'CTH 628',
	'KBo 41.66': 'CTH 628',
	'KBo 43.118': 'CTH 628',
	'KBo 43.122': 'CTH 628',
	'KBo 43.145': 'CTH 628',
	'KBo 43.200+': 'CTH 628',
	'KBo 43.213': 'CTH 628',
	'KBo 43.30': 'CTH 628',
	'KBo 43.71': 'CTH 628',
	'KBo 43.77': 'CTH 628',
	'KBo 43.78': 'CTH 628',
	'KBo 44.105': 'CTH 628',
	'KBo 44.121': 'CTH 628',
	'KBo 44.123': 'CTH 628',
	'KBo 44.125': 'CTH 628',
	'KBo 44.126': 'CTH 628',
	'KBo 44.157': 'CTH 628',
	'KBo 44.71': 'CTH 628',
	'KBo 45.49': 'CTH 628',
	'KBo 46.138': 'CTH 628',
	'KBo 46.140': 'CTH 628',
	'KBo 46.141': 'CTH 628',
	'KBo 46.143': 'CTH 628',
	'KBo 46.145': 'CTH 628',
	'KBo 46.33': 'CTH 628',
	'KBo 47.124': 'CTH 628',
	'KBo 47.131': 'CTH 628',
	'KBo 47.257': 'CTH 628',
	'KBo 47.265': 'CTH 628',
	'KBo 47.50': 'CTH 628',
	'KBo 47.66': 'CTH 628',
	'KBo 47.71': 'CTH 628',
	'KBo 48.36a+': 'CTH 628',
	'KBo 49.15': 'CTH 628',
	'KBo 49.230': 'CTH 628',
	'KBo 53.124': 'CTH 628',
	'KBo 53.125': 'CTH 628',
	'KBo 53.288': 'CTH 628',
	'KBo 55.236': 'CTH 628',
	'KBo 55.237': 'CTH 628',
	'KBo 60.186': 'CTH 628',
	'KBo 63.74': 'CTH 628',
	'KBo 64.367': 'CTH 628',
	'KBo 64.43+': 'CTH 628',
	'KBo 71.151': 'CTH 628',
	'KBo 71.60': 'CTH 628',
	'KBo 71.61': 'CTH 628',
	'KBo 71.62': 'CTH 628',
	'KBo 71.64': 'CTH 628',
	'KBo 71.88': 'CTH 628',
	'KBo 8.155': 'CTH 628',
	'KBo 8.72': 'CTH 628',
	'KBo 8.84': 'CTH 628',
	'KBo 9.123+': 'CTH 628',
	'KBo 9.133': 'CTH 628',
	'KUB 10.68': 'CTH 628',
	'KUB 12.12': 'CTH 628',
	'KUB 20.23+': 'CTH 628',
	'KUB 20.44': 'CTH 628',
	'KUB 20.49': 'CTH 628',
	'KUB 20.74': 'CTH 628',
	'KUB 20.95+': 'CTH 628',
	'KUB 20.98': 'CTH 628',
	'KUB 25.40': 'CTH 628',
	'KUB 25.43': 'CTH 628',
	'KUB 25.46': 'CTH 628',
	'KUB 25.49': 'CTH 628',
	'KUB 27.10': 'CTH 628',
	'KUB 27.19': 'CTH 628',
	'KUB 27.20': 'CTH 628',
	'KUB 27.47+': 'CTH 628',
	'KUB 27.5': 'CTH 628',
	'KUB 27.7': 'CTH 628',
	'KUB 30.40+': 'CTH 628',
	'KUB 32.102': 'CTH 628',
	'KUB 32.119': 'CTH 628',
	'KUB 32.128+': 'CTH 628',
	'KUB 32.54+': 'CTH 628',
	'KUB 32.77+': 'CTH 628',
	'KUB 32.90+': 'CTH 628',
	'KUB 34.111': 'CTH 628',
	'KUB 34.113+': 'CTH 628',
	'KUB 34.99': 'CTH 628',
	'KUB 40.100': 'CTH 628',
	'KUB 40.102+': 'CTH 628',
	'KUB 42.90': 'CTH 628',
	'KUB 44.17': 'CTH 628',
	'KUB 44.35': 'CTH 628',
	'KUB 44.49+': 'CTH 628',
	'KUB 45.52': 'CTH 628',
	'KUB 45.53': 'CTH 628',
	'KUB 45.55': 'CTH 628',
	'KUB 45.56+': 'CTH 628',
	'KUB 45.57+': 'CTH 628',
	'KUB 45.58+': 'CTH 628',
	'KUB 45.59+': 'CTH 628',
	'KUB 45.75': 'CTH 628',
	'KUB 47.73': 'CTH 628',
	'KUB 47.74': 'CTH 628',
	'KUB 51.16': 'CTH 628',
	'KUB 51.21': 'CTH 628',
	'KUB 51.4': 'CTH 628',
	'KUB 51.6': 'CTH 628',
	'KUB 51.73': 'CTH 628',
	'KUB 51.89': 'CTH 628',
	'KUB 54.47': 'CTH 628',
	'KUB 54.48': 'CTH 628',
	'KUB 54.53': 'CTH 628',
	'KUB 54.72': 'CTH 628',
	'KUB 55.29': 'CTH 628',
	'KUB 55.49': 'CTH 628',
	'KUB 55.51': 'CTH 628',
	'KUB 57.55': 'CTH 628',
	'KUB 60.51': 'CTH 628',
	'Merzifon I ': 'CTH 628',
	'Privat 141': 'CTH 628',
	'Privat 144': 'CTH 628',
	'VAT 6697a': 'CTH 628',
	'VBoT 64': 'CTH 628',
	'VBoT 89': 'CTH 628',
	'VSNF 12.22': 'CTH 628',
	'VSNF 12.23': 'CTH 628',
	'VSNF 12.34': 'CTH 628',
	'VSNF 12.38': 'CTH 628',
	'VSNF 12.70': 'CTH 628',
	'Çorum 2': 'CTH 628',
	'KBo 71.193': 'CTH 628',
	'KBo 17.102+': 'CTH 699',
	'KBo 21.34+': 'CTH 699',
	'KBo 24.7': 'CTH 699',
	'KBo 33.164': 'CTH 699',
	'KBo 43.203': 'CTH 699',
	'KBo 44.153': 'CTH 699',
	'KBo 53.216': 'CTH 699',
	'KBo 58.132': 'CTH 699',
	'KBo 63.86': 'CTH 699',
	'KBo 63.88': 'CTH 699',
	'ABoT 2.230': 'CTH 701',
	'ABoT 2.95': 'CTH 701',
	'ABoT 2.98': 'CTH 701',
	'CHDS 4.33': 'CTH 701',
	'CHDS 6.18': 'CTH 701',
	'CHDS 6.83': 'CTH 701',
	'DBH 43_2.104': 'CTH 701',
	'FHL 106': 'CTH 701',
	'HAM 1992.256.6': 'CTH 701',
	'HFAC 67': 'CTH 701',
	'IBoT 2.81': 'CTH 701',
	'IBoT 4.106+': 'CTH 701',
	'IBoT 4.107': 'CTH 701',
	'IBoT 4.29': 'CTH 701',
	'IBoT 4.85+': 'CTH 701',
	'KBo 19.136+': 'CTH 701',
	'KBo 22.134': 'CTH 701',
	'KBo 22.135': 'CTH 701',
	'KBo 22.165': 'CTH 701',
	'KBo 22.208': 'CTH 701',
	'KBo 23.14+': 'CTH 701',
	'KBo 23.44': 'CTH 701',
	'KBo 24.41': 'CTH 701',
	'KBo 24.43': 'CTH 701',
	'KBo 24.66+': 'CTH 701',
	'KBo 27.120': 'CTH 701',
	'KBo 27.121': 'CTH 701',
	'KBo 27.125': 'CTH 701',
	'KBo 27.126': 'CTH 701',
	'KBo 27.136': 'CTH 701',
	'KBo 27.138': 'CTH 701',
	'KBo 27.141': 'CTH 701',
	'KBo 27.142': 'CTH 701',
	'KBo 27.143': 'CTH 701',
	'KBo 27.145': 'CTH 701',
	'KBo 27.146+': 'CTH 701',
	'KBo 27.148': 'CTH 701',
	'KBo 27.152': 'CTH 701',
	'KBo 27.155': 'CTH 701',
	'KBo 27.160': 'CTH 701',
	'KBo 27.166': 'CTH 701',
	'KBo 27.187': 'CTH 701',
	'KBo 33.110+': 'CTH 701',
	'KBo 33.117+': 'CTH 701',
	'KBo 33.124+': 'CTH 701',
	'KBo 33.18': 'CTH 701',
	'KBo 33.19+': 'CTH 701',
	'KBo 33.20': 'CTH 701',
	'KBo 33.21': 'CTH 701',
	'KBo 33.22': 'CTH 701',
	'KBo 33.23': 'CTH 701',
	'KBo 33.24+': 'CTH 701',
	'KBo 33.25+': 'CTH 701',
	'KBo 33.27': 'CTH 701',
	'KBo 33.28': 'CTH 701',
	'KBo 33.29+': 'CTH 701',
	'KBo 33.30+': 'CTH 701',
	'KBo 33.30a': 'CTH 701',
	'KBo 33.30b': 'CTH 701',
	'KBo 33.31': 'CTH 701',
	'KBo 33.32': 'CTH 701',
	'KBo 33.33': 'CTH 701',
	'KBo 33.34+': 'CTH 701',
	'KBo 33.35+': 'CTH 701',
	'KBo 34.232': 'CTH 701',
	'KBo 35.121+': 'CTH 701',
	'KBo 35.176': 'CTH 701',
	'KBo 35.230': 'CTH 701',
	'KBo 35.248': 'CTH 701',
	'KBo 35.67+': 'CTH 701',
	'KBo 35.70': 'CTH 701',
	'KBo 35.71': 'CTH 701',
	'KBo 35.72': 'CTH 701',
	'KBo 35.73': 'CTH 701',
	'KBo 35.74': 'CTH 701',
	'KBo 35.75': 'CTH 701',
	'KBo 35.78+': 'CTH 701',
	'KBo 35.80': 'CTH 701',
	'KBo 35.82': 'CTH 701',
	'KBo 35.83': 'CTH 701',
	'KBo 35.85+': 'CTH 701',
	'KBo 35.89+': 'CTH 701',
	'KBo 35.90': 'CTH 701',
	'KBo 37.25+': 'CTH 701',
	'KBo 38.130': 'CTH 701',
	'KBo 38.259+': 'CTH 701',
	'KBo 38.261+': 'CTH 701',
	'KBo 38.281+': 'CTH 701',
	'KBo 40.314+': 'CTH 701',
	'KBo 40.35+': 'CTH 701',
	'KBo 40.38+': 'CTH 701',
	'KBo 40.83': 'CTH 701',
	'KBo 46.109': 'CTH 701',
	'KBo 46.112': 'CTH 701',
	'KBo 46.296': 'CTH 701',
	'KBo 47.129': 'CTH 701',
	'KBo 47.260': 'CTH 701',
	'KBo 47.268': 'CTH 701',
	'KBo 48.62': 'CTH 701',
	'KBo 51.182': 'CTH 701',
	'KBo 51.183': 'CTH 701',
	'KBo 51.184': 'CTH 701',
	'KBo 51.235': 'CTH 701',
	'KBo 51.250': 'CTH 701',
	'KBo 52.187': 'CTH 701',
	'KBo 52.52': 'CTH 701',
	'KBo 53.247': 'CTH 701',
	'KBo 54.218': 'CTH 701',
	'KBo 54.219+': 'CTH 701',
	'KBo 54.75': 'CTH 701',
	'KBo 55.266': 'CTH 701',
	'KBo 57.97+': 'CTH 701',
	'KBo 58.211+': 'CTH 701',
	'KBo 58.53': 'CTH 701',
	'KBo 58.61': 'CTH 701',
	'KBo 59.165': 'CTH 701',
	'KBo 59.166': 'CTH 701',
	'KBo 59.56': 'CTH 701',
	'KBo 59.62': 'CTH 701',
	'KBo 60.215': 'CTH 701',
	'KBo 60.216': 'CTH 701',
	'KBo 61.240': 'CTH 701',
	'KBo 64.168': 'CTH 701',
	'KBo 64.71': 'CTH 701',
	'KBo 66.116': 'CTH 701',
	'KBo 66.139': 'CTH 701',
	'KBo 66.168': 'CTH 701',
	'KBo 67.263': 'CTH 701',
	'KBo 68.108': 'CTH 701',
	'KBo 68.316': 'CTH 701',
	'KBo 69.11': 'CTH 701',
	'KBo 71.2+': 'CTH 701',
	'KBo 8.152': 'CTH 701',
	'KBo 8.157+': 'CTH 701',
	'KUB 28.85': 'CTH 701',
	'KUB 32.35': 'CTH 701',
	'KUB 32.36': 'CTH 701',
	'KUB 32.38+': 'CTH 701',
	'KUB 32.42+': 'CTH 701',
	'KUB 32.44': 'CTH 701',
	'KUB 32.53': 'CTH 701',
	'KUB 32.56': 'CTH 701',
	'KUB 32.57+': 'CTH 701',
	'KUB 32.58+': 'CTH 701',
	'KUB 44.46': 'CTH 701',
	'KUB 45.13': 'CTH 701',
	'KUB 45.14': 'CTH 701',
	'KUB 45.15': 'CTH 701',
	'KUB 45.16': 'CTH 701',
	'KUB 45.4': 'CTH 701',
	'KUB 45.7': 'CTH 701',
	'KUB 45.9': 'CTH 701',
	'KUB 47.101': 'CTH 701',
	'KUB 47.38': 'CTH 701',
	'KUB 47.39': 'CTH 701',
	'KUB 47.41': 'CTH 701',
	'KUB 47.55': 'CTH 701',
	'KUB 47.84': 'CTH 701',
	'KUB 51.85': 'CTH 701',
	'KUB 52.105': 'CTH 701',
	'KUB 55.31': 'CTH 701',
	'KUB 56.41': 'CTH 701',
	'UBT 111': 'CTH 701',
	'UBT 63': 'CTH 701',
	'KBo 19.148': 'CTH 702',
	'KBo 33.108+': 'CTH 702',
	'KUB 9.2': 'CTH 702',
	'ABoT 2.232': 'CTH 704',
	'CHDS 5.127': 'CTH 704',
	'CHDS 6.65': 'CTH 704',
	'IBoT 2.42': 'CTH 704',
	'KBo 20.109+': 'CTH 704',
	'KBo 22.231': 'CTH 704',
	'KBo 23.16': 'CTH 704',
	'KBo 23.67+': 'CTH 704',
	'KBo 24.47+': 'CTH 704',
	'KBo 24.73': 'CTH 704',
	'KBo 25.194': 'CTH 704',
	'KBo 27.178': 'CTH 704',
	'KBo 27.195': 'CTH 704',
	'KBo 30.138': 'CTH 704',
	'KBo 33.133': 'CTH 704',
	'KBo 33.140': 'CTH 704',
	'KBo 33.166': 'CTH 704',
	'KBo 33.208+': 'CTH 704',
	'KBo 33.209': 'CTH 704',
	'KBo 33.213': 'CTH 704',
	'KBo 34.233': 'CTH 704',
	'KBo 35.123': 'CTH 704',
	'KBo 35.124': 'CTH 704',
	'KBo 35.125+': 'CTH 704',
	'KBo 35.126': 'CTH 704',
	'KBo 35.127': 'CTH 704',
	'KBo 35.129': 'CTH 704',
	'KBo 35.130': 'CTH 704',
	'KBo 35.131': 'CTH 704',
	'KBo 35.156+': 'CTH 704',
	'KBo 35.172': 'CTH 704',
	'KBo 35.177': 'CTH 704',
	'KBo 39.157': 'CTH 704',
	'KBo 39.159': 'CTH 704',
	'KBo 40.84': 'CTH 704',
	'KBo 40.85': 'CTH 704',
	'KBo 40.86': 'CTH 704',
	'KBo 40.87': 'CTH 704',
	'KBo 40.91+': 'CTH 704',
	'KBo 41.106+': 'CTH 704',
	'KBo 42.34': 'CTH 704',
	'KBo 43.151': 'CTH 704',
	'KBo 43.207': 'CTH 704',
	'KBo 43.209': 'CTH 704',
	'KBo 43.211': 'CTH 704',
	'KBo 44.192': 'CTH 704',
	'KBo 45.253': 'CTH 704',
	'KBo 46.110': 'CTH 704',
	'KBo 51.185': 'CTH 704',
	'KBo 51.186': 'CTH 704',
	'KBo 52.203': 'CTH 704',
	'KBo 52.204+': 'CTH 704',
	'KBo 57.206': 'CTH 704',
	'KBo 57.207': 'CTH 704',
	'KBo 58.212+': 'CTH 704',
	'KBo 58.213': 'CTH 704',
	'KBo 62.71': 'CTH 704',
	'KBo 63.85': 'CTH 704',
	'KBo 64.169': 'CTH 704',
	'KBo 65.141': 'CTH 704',
	'KBo 7.44+': 'CTH 704',
	'KUB 10.51': 'CTH 704',
	'KUB 20.93+': 'CTH 704',
	'KUB 25.44': 'CTH 704',
	'KUB 27.8': 'CTH 704',
	'KUB 32.93+': 'CTH 704',
	'KUB 32.97+': 'CTH 704',
	'KUB 47.77': 'CTH 704',
	'KUB 60.23': 'CTH 704',
	'CHDS 5.174': 'CTH 705',
	'HT 54': 'CTH 705',
	'IBoT 1.17': 'CTH 705',
	'IBoT 2.26': 'CTH 705',
	'IBoT 2.57': 'CTH 705',
	'IBoT 2.70': 'CTH 705',
	'IBoT 4.147': 'CTH 705',
	'KBo 11.6': 'CTH 705',
	'KBo 13.108': 'CTH 705',
	'KBo 13.149': 'CTH 705',
	'KBo 14.138+': 'CTH 705',
	'KBo 14.139': 'CTH 705',
	'KBo 14.140': 'CTH 705',
	'KBo 15.41+': 'CTH 705',
	'KBo 15.42+': 'CTH 705',
	'KBo 15.45': 'CTH 705',
	'KBo 17.37': 'CTH 705',
	'KBo 20.43': 'CTH 705',
	'KBo 20.62': 'CTH 705',
	'KBo 21.51': 'CTH 705',
	'KBo 27.116+': 'CTH 705',
	'KBo 27.167+': 'CTH 705',
	'KBo 27.182': 'CTH 705',
	'KBo 27.199': 'CTH 705',
	'KBo 3.14+': 'CTH 705',
	'KBo 33.142': 'CTH 705',
	'KBo 33.161': 'CTH 705',
	'KBo 33.214': 'CTH 705',
	'KBo 33.63': 'CTH 705',
	'KBo 34.101': 'CTH 705',
	'KBo 34.234': 'CTH 705',
	'KBo 35.132': 'CTH 705',
	'KBo 35.134': 'CTH 705',
	'KBo 35.135': 'CTH 705',
	'KBo 35.137+': 'CTH 705',
	'KBo 35.138': 'CTH 705',
	'KBo 35.139': 'CTH 705',
	'KBo 35.140+': 'CTH 705',
	'KBo 35.141': 'CTH 705',
	'KBo 35.144': 'CTH 705',
	'KBo 35.146': 'CTH 705',
	'KBo 35.231': 'CTH 705',
	'KBo 35.244': 'CTH 705',
	'KBo 38.276': 'CTH 705',
	'KBo 40.41': 'CTH 705',
	'KBo 40.88': 'CTH 705',
	'KBo 40.97': 'CTH 705',
	'KBo 41.57': 'CTH 705',
	'KBo 41.97': 'CTH 705',
	'KBo 42.75': 'CTH 705',
	'KBo 43.254': 'CTH 705',
	'KBo 44.100': 'CTH 705',
	'KBo 45.250+': 'CTH 705',
	'KBo 45.251': 'CTH 705',
	'KBo 46.111': 'CTH 705',
	'KBo 46.114': 'CTH 705',
	'KBo 47.111': 'CTH 705',
	'KBo 47.127': 'CTH 705',
	'KBo 49.282': 'CTH 705',
	'KBo 54.220': 'CTH 705',
	'KBo 54.221': 'CTH 705',
	'KBo 54.78': 'CTH 705',
	'KBo 59.167': 'CTH 705',
	'KBo 61.268': 'CTH 705',
	'KBo 66.107': 'CTH 705',
	'KBo 71.67': 'CTH 705',
	'KUB 25.45': 'CTH 705',
	'KUB 25.50': 'CTH 705',
	'KUB 27.11': 'CTH 705',
	'KUB 27.14': 'CTH 705',
	'KUB 27.2': 'CTH 705',
	'KUB 27.21': 'CTH 705',
	'KUB 27.27': 'CTH 705',
	'KUB 27.33': 'CTH 705',
	'KUB 27.9': 'CTH 705',
	'KUB 32.52': 'CTH 705',
	'KUB 32.66': 'CTH 705',
	'KUB 32.75': 'CTH 705',
	'KUB 32.78': 'CTH 705',
	'KUB 32.89': 'CTH 705',
	'KUB 32.91': 'CTH 705',
	'KUB 34.95': 'CTH 705',
	'KUB 34.98': 'CTH 705',
	'KUB 41.48': 'CTH 705',
	'KUB 45.42': 'CTH 705',
	'KUB 45.44': 'CTH 705',
	'KUB 45.48+': 'CTH 705',
	'KUB 45.66': 'CTH 705',
	'KUB 45.69': 'CTH 705',
	'KUB 45.74': 'CTH 705',
	'KUB 46.7+': 'CTH 705',
	'KUB 51.67': 'CTH 705',
	'KUB 54.80+': 'CTH 705',
	'VSNF 12.25': 'CTH 705',
	'VSNF 12.50': 'CTH 705',
	'Bo 7188+': 'CTH 706',
	'CHDS 5.143': 'CTH 706',
	'IBoT 1.11': 'CTH 706',
	'KBo 14.128': 'CTH 706',
	'KBo 14.133': 'CTH 706',
	'KBo 14.141+': 'CTH 706',
	'KBo 17.103+': 'CTH 706',
	'KBo 21.31+': 'CTH 706',
	'KBo 22.138': 'CTH 706',
	'KBo 22.180': 'CTH 706',
	'KBo 23.39': 'CTH 706',
	'KBo 23.70': 'CTH 706',
	'KBo 27.109': 'CTH 706',
	'KBo 30.93': 'CTH 706',
	'KBo 33.114': 'CTH 706',
	'KBo 33.136': 'CTH 706',
	'KBo 33.154': 'CTH 706',
	'KBo 33.88': 'CTH 706',
	'KBo 33.97': 'CTH 706',
	'KBo 35.147': 'CTH 706',
	'KBo 35.148': 'CTH 706',
	'KBo 35.150+': 'CTH 706',
	'KBo 35.153': 'CTH 706',
	'KBo 35.154': 'CTH 706',
	'KBo 35.155': 'CTH 706',
	'KBo 35.157': 'CTH 706',
	'KBo 35.162+': 'CTH 706',
	'KBo 35.19': 'CTH 706',
	'KBo 35.191': 'CTH 706',
	'KBo 35.218+': 'CTH 706',
	'KBo 38.297+': 'CTH 706',
	'KBo 39.160': 'CTH 706',
	'KBo 39.161': 'CTH 706',
	'KBo 39.164': 'CTH 706',
	'KBo 39.165': 'CTH 706',
	'KBo 39.166+': 'CTH 706',
	'KBo 39.167': 'CTH 706',
	'KBo 39.191+': 'CTH 706',
	'KBo 39.42+': 'CTH 706',
	'KBo 39.43': 'CTH 706',
	'KBo 40.29+': 'CTH 706',
	'KBo 40.90': 'CTH 706',
	'KBo 42.12': 'CTH 706',
	'KBo 43.199+': 'CTH 706',
	'KBo 43.210': 'CTH 706',
	'KBo 43.44+': 'CTH 706',
	'KBo 44.104': 'CTH 706',
	'KBo 44.249': 'CTH 706',
	'KBo 45.254': 'CTH 706',
	'KBo 46.115': 'CTH 706',
	'KBo 46.16': 'CTH 706',
	'KBo 46.246': 'CTH 706',
	'KBo 49.119': 'CTH 706',
	'KBo 51.94': 'CTH 706',
	'KBo 56.200': 'CTH 706',
	'KBo 56.95': 'CTH 706',
	'KBo 57.208': 'CTH 706',
	'KBo 58.215': 'CTH 706',
	'KBo 61.128': 'CTH 706',
	'KBo 65.78': 'CTH 706',
	'KBo 67.153': 'CTH 706',
	'KBo 7.60': 'CTH 706',
	'KBo 8.114': 'CTH 706',
	'KBo 8.93': 'CTH 706',
	'KBo 9.118': 'CTH 706',
	'KUB 10.92': 'CTH 706',
	'KUB 20.35': 'CTH 706',
	'KUB 25.34': 'CTH 706',
	'KUB 25.41': 'CTH 706',
	'KUB 27.22': 'CTH 706',
	'KUB 32.60+': 'CTH 706',
	'KUB 32.76': 'CTH 706',
	'KUB 32.95': 'CTH 706',
	'KUB 32.98': 'CTH 706',
	'KUB 43.54': 'CTH 706',
	'KUB 44.45': 'CTH 706',
	'KUB 44.47': 'CTH 706',
	'KUB 45.65': 'CTH 706',
	'KUB 45.67+': 'CTH 706',
	'KUB 47.46': 'CTH 706',
	'KUB 47.80': 'CTH 706',
	'KUB 47.82': 'CTH 706',
	'KUB 51.19': 'CTH 706',
	'KUB 55.59': 'CTH 706',
	'KUB 57.52': 'CTH 706',
	'KUB 60.34': 'CTH 706',
	'KUB 32.130': 'CTH 712',
	'DAAM 1.74': 'CTH 712',
	'DAAM 1.75': 'CTH 712',
	'DAAM 1.76': 'CTH 712',
	'DAAM 1.77': 'CTH 712',
	'DAAM 1.86': 'CTH 712',
	'DBH 54.16': 'CTH 712',
	'IBoT 2.59': 'CTH 712',
	'KBo 33.147': 'CTH 712',
	'KBo 35.159': 'CTH 712',
	'KBo 35.160': 'CTH 712',
	'KBo 35.161': 'CTH 712',
	'KBo 35.164': 'CTH 712',
	'KBo 35.165': 'CTH 712',
	'KBo 35.168': 'CTH 712',
	'KBo 39.162': 'CTH 712',
	'KBo 48.173': 'CTH 712',
	'KBo 52.205+': 'CTH 712',
	'KBo 52.206': 'CTH 712',
	'KBo 54.222+': 'CTH 712',
	'KBo 57.209+': 'CTH 712',
	'KBo 8.120': 'CTH 712',
	'KUB 27.1': 'CTH 712',
	'KUB 27.3': 'CTH 712',
	'KUB 27.6': 'CTH 712',
	'KUB 47.81': 'CTH 712',
	'KUB 55.17': 'CTH 712',
	'KBo 44.114+': 'CTH 713',
	'KUB 12.5': 'CTH 713',
	'KUB 45.32': 'CTH 713',
	'KUB 45.33': 'CTH 713',
	'KBo 34.1': 'CTH 714',
	'KBo 34.238': 'CTH 714',
	'KBo 34.240': 'CTH 714',
	'KBo 40.34+': 'CTH 714',
	'KBo 40.92': 'CTH 714',
	'KBo 43.212': 'CTH 714',
	'KBo 43.215': 'CTH 714',
	'KBo 46.247': 'CTH 714',
	'KBo 52.207': 'CTH 714',
	'KBo 52.208': 'CTH 714',
	'KBo 54.223+': 'CTH 714',
	'KBo 57.210': 'CTH 714',
	'KBo 66.110+': 'CTH 714',
	'KUB 27.16': 'CTH 714',
	'KUB 30.76': 'CTH 714',
	'KBo 33.163': 'CTH 715',
	'KBo 49.287': 'CTH 715',
	'KUB 10.63': 'CTH 715',
	'KBo 2.9+': 'CTH 716',
	'KBo 21.48': 'CTH 716',
	'KBo 24.69': 'CTH 716',
	'KBo 35.170+': 'CTH 716',
	'KBo 39.170': 'CTH 716',
	'KBo 44.193+': 'CTH 716',
	'KUB 27.37': 'CTH 716',
	'KUB 32.122': 'CTH 716',
	'KUB 45.43': 'CTH 716',
	'ABoT 2.105': 'CTH 720',
	'DAAM 3.65': 'CTH 720',
	'FHL 181': 'CTH 720',
	'HT 30': 'CTH 720',
	'KBo 19.146': 'CTH 720',
	'KBo 22.162': 'CTH 720',
	'KBo 27.132': 'CTH 720',
	'KBo 27.153': 'CTH 720',
	'KBo 34.96': 'CTH 720',
	'KBo 34.97': 'CTH 720',
	'KBo 42.140': 'CTH 720',
	'KBo 51.187': 'CTH 720',
	'KBo 56.150': 'CTH 720',
	'KBo 56.197': 'CTH 720',
	'KBo 60.334': 'CTH 720',
	'KBo 64.171': 'CTH 720',
	'KUB 12.15': 'CTH 720',
	'KUB 27.12': 'CTH 720',
	'KUB 27.18': 'CTH 720',
	'KUB 41.25': 'CTH 720',
	'KUB 45.46': 'CTH 720',
	'KUB 47.62': 'CTH 720',
	'KUB 47.65+': 'CTH 720',
	'KUB 47.71': 'CTH 720',
	'KUB 7.49': 'CTH 720',
	'UBT 132': 'CTH 720',
	'KBo 21.46': 'CTH 774',
	'KBo 27.179': 'CTH 774',
	'KBo 27.184': 'CTH 774',
	'KBo 27.204': 'CTH 774',
	'KBo 27.205': 'CTH 774',
	'KBo 27.206': 'CTH 774',
	'KBo 27.207': 'CTH 774',
	'KBo 27.208': 'CTH 774',
	'KBo 27.209': 'CTH 774',
	'KBo 27.210': 'CTH 774',
	'KBo 27.211': 'CTH 774',
	'KBo 27.212': 'CTH 774',
	'KBo 27.213': 'CTH 774',
	'KBo 27.214': 'CTH 774',
	'KBo 27.215': 'CTH 774',
	'KBo 27.75': 'CTH 774',
	'KBo 32.223': 'CTH 774',
	'KBo 33.106': 'CTH 774',
	'KBo 33.109': 'CTH 774',
	'KBo 33.112': 'CTH 774',
	'KBo 33.130': 'CTH 774',
	'KBo 33.134': 'CTH 774',
	'KBo 33.135': 'CTH 774',
	'KBo 33.51+': 'CTH 774',
	'KBo 35.1': 'CTH 774',
	'KBo 35.2': 'CTH 774',
	'KBo 35.24+': 'CTH 774',
	'KBo 35.3': 'CTH 774',
	'KBo 35.4': 'CTH 774',
	'KBo 35.5': 'CTH 774',
	'KBo 35.6': 'CTH 774',
	'KBo 35.7': 'CTH 774',
	'KBo 49.60': 'CTH 774',
	'KBo 56.198': 'CTH 774',
	'KBo 62.54': 'CTH 774',
	'KBo 7.65': 'CTH 774',
	'KBo 8.135': 'CTH 774',
	'KBo 8.137': 'CTH 774',
	'KBo 8.146': 'CTH 774',
	'KUB 27.44': 'CTH 774',
	'KUB 29.12': 'CTH 774',
	'KUB 45.31': 'CTH 774',
	'KUB 45.70': 'CTH 774',
	'KUB 47.92': 'CTH 774',
	'KUB 47.93': 'CTH 774',
	'KUB 47.94': 'CTH 774',
	'KUB 47.95': 'CTH 774',
	'KUB 47.96': 'CTH 774',
	'KUB 8.31': 'CTH 774',
	'KUB 8.32': 'CTH 774',
	'KUB 8.47': 'CTH 774',
	'KBo 35.108': 'CTH 775',
	'KUB 27.31': 'CTH 775',
	'KUB 27.38': 'CTH 775',
	'KUB 31.3': 'CTH 775',
	'KUB 45.25': 'CTH 775',
	'KBo 27.217': 'CTH 776',
	'KBo 33.137+': 'CTH 776',
	'KBo 33.67': 'CTH 776',
	'KBo 35.171': 'CTH 776',
	'KBo 35.183': 'CTH 776',
	'KBo 51.224+': 'CTH 776',
	'HHCTO 14': 'CTH 777',
	'IBoT 2.39': 'CTH 777',
	'KBo 15.70+': 'CTH 777',
	'KBo 15.72+': 'CTH 777',
	'KBo 20.124+': 'CTH 777',
	'KBo 20.127': 'CTH 777',
	'KBo 20.130': 'CTH 777',
	'KBo 20.131': 'CTH 777',
	'KBo 20.138': 'CTH 777',
	'KBo 21.43': 'CTH 777',
	'KBo 21.44+': 'CTH 777',
	'KBo 23.35': 'CTH 777',
	'KBo 27.102+': 'CTH 777',
	'KBo 27.92+': 'CTH 777',
	'KBo 27.93+': 'CTH 777',
	'KBo 27.95+': 'CTH 777',
	'KBo 27.96': 'CTH 777',
	'KBo 33.1+': 'CTH 777',
	'KBo 33.12+': 'CTH 777',
	'KBo 33.15+': 'CTH 777',
	'KBo 33.16': 'CTH 777',
	'KBo 33.43+': 'CTH 777',
	'KBo 33.5': 'CTH 777',
	'KBo 35.14': 'CTH 777',
	'KBo 35.63': 'CTH 777',
	'KBo 35.65': 'CTH 777',
	'KBo 40.123+': 'CTH 777',
	'KBo 52.216': 'CTH 777',
	'KBo 53.226': 'CTH 777',
	'KBo 62.22': 'CTH 777',
	'KUB 32.19+': 'CTH 777',
	'KUB 32.23+': 'CTH 777',
	'KUB 32.25+': 'CTH 777',
	'KUB 32.40+': 'CTH 777',
	'KUB 32.51+': 'CTH 777',
	'Or. 90_1473': 'CTH 777',
	'Or. 90_1494+': 'CTH 777',
	'Or. 90_393+': 'CTH 777',
	'DAAM 1.29': 'CTH 778',
	'FHG 22': 'CTH 778',
	'HHCTO 12': 'CTH 778',
	'IBoT 2.40': 'CTH 778',
	'KBo 14.135': 'CTH 778',
	'KBo 2.21': 'CTH 778',
	'KBo 20.137': 'CTH 778',
	'KBo 20.139': 'CTH 778',
	'KBo 20.141': 'CTH 778',
	'KBo 20.144': 'CTH 778',
	'KBo 23.32+': 'CTH 778',
	'KBo 23.33+': 'CTH 778',
	'KBo 27.106': 'CTH 778',
	'KBo 27.107': 'CTH 778',
	'KBo 27.118': 'CTH 778',
	'KBo 27.190': 'CTH 778',
	'KBo 27.192': 'CTH 778',
	'KBo 27.78': 'CTH 778',
	'KBo 27.86': 'CTH 778',
	'KBo 27.90': 'CTH 778',
	'KBo 27.94': 'CTH 778',
	'KBo 27.98': 'CTH 778',
	'KBo 33.13': 'CTH 778',
	'KBo 33.2+': 'CTH 778',
	'KBo 33.48': 'CTH 778',
	'KBo 33.49+': 'CTH 778',
	'KBo 33.6': 'CTH 778',
	'KBo 33.8+': 'CTH 778',
	'KBo 33.9': 'CTH 778',
	'KBo 39.262+': 'CTH 778',
	'KBo 40.94': 'CTH 778',
	'KBo 40.95': 'CTH 778',
	'KBo 5.10': 'CTH 778',
	'KBo 53.227': 'CTH 778',
	'KBo 69.120': 'CTH 778',
	'KBo 71.166': 'CTH 778',
	'KBo 8.141': 'CTH 778',
	'KBo 8.148': 'CTH 778',
	'KBo 8.154': 'CTH 778',
	'KBo 9.137+': 'CTH 778',
	'KUB 27.39': 'CTH 778',
	'KUB 32.21': 'CTH 778',
	'KUB 45.17': 'CTH 778',
	'KUB 45.18': 'CTH 778',
	'KUB 45.2': 'CTH 778',
	'KUB 45.45': 'CTH 778',
	'KUB 45.8a+': 'CTH 778',
	'KUB 47.24': 'CTH 778',
	'KUB 47.28': 'CTH 778',
	'KUB 47.33': 'CTH 778',
	'KUB 47.34': 'CTH 778',
	'KUB 47.40+': 'CTH 778',
	'KUB 47.97': 'CTH 778',
	'Privat 8': 'CTH 778',
	'KBo 57.29': 'CTH 779',
	'KUB 7.58': 'CTH 779',
	'KBo 51.47': 'CTH 780',
	'ABoT 2.245': 'CTH 780',
	'ABoT 2.267': 'CTH 780',
	'CHDS 3.38': 'CTH 780',
	'CHDS 5.97': 'CTH 780',
	'DBH 43_2.77': 'CTH 780',
	'FHL 23': 'CTH 780',
	'FHL 39': 'CTH 780',
	'HT 94': 'CTH 780',
	'KBo 12.85+': 'CTH 780',
	'KBo 19.139': 'CTH 780',
	'KBo 2.32': 'CTH 780',
	'KBo 20.49': 'CTH 780',
	'KBo 23.23+': 'CTH 780',
	'KBo 23.24': 'CTH 780',
	'KBo 31.143': 'CTH 780',
	'KBo 33.119': 'CTH 780',
	'KBo 34.67': 'CTH 780',
	'KBo 35.118': 'CTH 780',
	'KBo 35.17': 'CTH 780',
	'KBo 35.92': 'CTH 780',
	'KBo 35.93': 'CTH 780',
	'KBo 35.94': 'CTH 780',
	'KBo 35.95+': 'CTH 780',
	'KBo 44.82': 'CTH 780',
	'KBo 45.265': 'CTH 780',
	'KBo 45.266': 'CTH 780',
	'KBo 48.175+': 'CTH 780',
	'KBo 51.13': 'CTH 780',
	'KBo 51.273': 'CTH 780',
	'KBo 52.210': 'CTH 780',
	'KBo 57.215+': 'CTH 780',
	'KBo 59.15': 'CTH 780',
	'KBo 63.311': 'CTH 780',
	'KBo 63.345': 'CTH 780',
	'KBo 64.186': 'CTH 780',
	'KBo 65.359': 'CTH 780',
	'KBo 67.91': 'CTH 780',
	'KBo 69.326': 'CTH 780',
	'KUB 15.41': 'CTH 780',
	'KUB 17.27+': 'CTH 780',
	'KUB 17.30': 'CTH 780',
	'KUB 24.13': 'CTH 780',
	'KUB 34.110': 'CTH 780',
	'KUB 41.21': 'CTH 780',
	'KUB 45.21': 'CTH 780',
	'KUB 58.106': 'CTH 780',
	'KUB 58.107+': 'CTH 780',
	'KUB 58.74': 'CTH 780',
	'KUB 59.71+': 'CTH 780',
	'KUB 59.72': 'CTH 780',
	'KUB 59.73': 'CTH 780',
	'UBT 45': 'CTH 780',
	'VBoT 132': 'CTH 780',
	'CHDS 4.229': 'CTH 781',
	'KBo 12.118': 'CTH 781',
	'KBo 13.116': 'CTH 781',
	'KBo 21.18': 'CTH 781',
	'KBo 35.100': 'CTH 781',
	'KBo 35.40': 'CTH 781',
	'KBo 35.96': 'CTH 781',
	'KBo 35.97': 'CTH 781',
	'KBo 35.98': 'CTH 781',
	'KBo 38.55': 'CTH 781',
	'KBo 53.225': 'CTH 781',
	'KBo 58.228': 'CTH 781',
	'KBo 64.187': 'CTH 781',
	'KUB 36.36': 'CTH 781',
	'KUB 47.48': 'CTH 781',
	'KUB 58.112': 'CTH 781',
	'KUB 58.80': 'CTH 781',
	'VBoT 16': 'CTH 781',
	'KBo 19.135': 'CTH 782',
	'KBo 35.109+': 'CTH 782',
	'KBo 54.54': 'CTH 782',
	'KBo 68.111': 'CTH 782',
	'KUB 27.28': 'CTH 782',
	'KUB 45.22': 'CTH 782',
	'KUB 7.56': 'CTH 782',
	'KBo 22.114': 'CTH 783',
	'KBo 55.140': 'CTH 783',
	'KBo 9.116': 'CTH 783',
	'KUB 30.26': 'CTH 783',
	'KUB 27.42': 'CTH 784',
	'ABoT 2.219': 'CTH 785',
	'DBH 46_2.148': 'CTH 785',
	'DBH 46_2.24': 'CTH 785',
	'KBo 14.129': 'CTH 785',
	'KBo 19.133': 'CTH 785',
	'KBo 20.122': 'CTH 785',
	'KBo 23.71': 'CTH 785',
	'KBo 34.187+': 'CTH 785',
	'KBo 42.2': 'CTH 785',
	'KBo 48.190': 'CTH 785',
	'KBo 61.316': 'CTH 785',
	'KBo 63.111': 'CTH 785',
	'KBo 8.86+': 'CTH 785',
	'KBo 8.88+': 'CTH 785',
	'KBo 9.130': 'CTH 785',
	'KUB 44.7': 'CTH 785',
	'KUB 45.49': 'CTH 785',
	'KUB 45.78': 'CTH 785',
	'KBo 17.86+': 'CTH 786',
	'KBo 20.119': 'CTH 786',
	'KBo 21.50': 'CTH 786',
	'KBo 55.173': 'CTH 786',
	'KUB 45.41': 'CTH 786',
	'Or. 90_175': 'CTH 786',
	'DAAM 1.78': 'CTH 787',
	'KBo 11.7': 'CTH 787',
	'KBo 14.143': 'CTH 787',
	'KBo 2.18': 'CTH 787',
	'KBo 21.30': 'CTH 787',
	'KBo 27.191': 'CTH 787',
	'KBo 30.175': 'CTH 787',
	'KBo 33.151+': 'CTH 787',
	'KBo 33.157': 'CTH 787',
	'KBo 35.242': 'CTH 787',
	'KBo 39.186+': 'CTH 787',
	'KBo 43.224': 'CTH 787',
	'KBo 43.226': 'CTH 787',
	'KBo 46.255': 'CTH 787',
	'KBo 47.184': 'CTH 787',
	'KBo 56.199': 'CTH 787',
	'KBo 62.21': 'CTH 787',
	'KBo 7.46': 'CTH 787',
	'KUB 32.86+': 'CTH 787',
	'KUB 41.31': 'CTH 787',
	'KUB 45.80': 'CTH 787',
	'KUB 47.67': 'CTH 787',
	'KUB 47.87': 'CTH 787',
	'KUB 60.154': 'CTH 787',
	'IBoT 4.116': 'CTH 788',
	'KBo 11.19+': 'CTH 788',
	'KBo 19.141': 'CTH 788',
	'KBo 19.145': 'CTH 788',
	'KBo 27.176': 'CTH 788',
	'KBo 27.185': 'CTH 788',
	'KBo 3.48': 'CTH 788',
	'KBo 33.45': 'CTH 788',
	'KBo 35.99': 'CTH 788',
	'KBo 40.220': 'CTH 788',
	'KUB 12.47': 'CTH 788',
	'KUB 32.121': 'CTH 788',
	'KUB 34.101': 'CTH 788',
	'KUB 47.19': 'CTH 788',
	'Kelly A': 'CTH 788',
	'KBo 32.10': 'CTH 789',
	'KBo 32.100': 'CTH 789',
	'KBo 32.101': 'CTH 789',
	'KBo 32.102': 'CTH 789',
	'KBo 32.103a': 'CTH 789',
	'KBo 32.103b': 'CTH 789',
	'KBo 32.103c': 'CTH 789',
	'KBo 32.103d': 'CTH 789',
	'KBo 32.103e': 'CTH 789',
	'KBo 32.103f': 'CTH 789',
	'KBo 32.103g': 'CTH 789',
	'KBo 32.103h': 'CTH 789',
	'KBo 32.103i': 'CTH 789',
	'KBo 32.103j': 'CTH 789',
	'KBo 32.103k': 'CTH 789',
	'KBo 32.103l': 'CTH 789',
	'KBo 32.103m': 'CTH 789',
	'KBo 32.103n': 'CTH 789',
	'KBo 32.103o': 'CTH 789',
	'KBo 32.103p': 'CTH 789',
	'KBo 32.103q': 'CTH 789',
	'KBo 32.104': 'CTH 789',
	'KBo 32.107': 'CTH 789',
	'KBo 32.109': 'CTH 789',
	'KBo 32.11': 'CTH 789',
	'KBo 32.110': 'CTH 789',
	'KBo 32.113': 'CTH 789',
	'KBo 32.12': 'CTH 789',
	'KBo 32.13+': 'CTH 789',
	'KBo 32.14': 'CTH 789',
	'KBo 32.15': 'CTH 789',
	'KBo 32.16': 'CTH 789',
	'KBo 32.17': 'CTH 789',
	'KBo 32.18': 'CTH 789',
	'KBo 32.19': 'CTH 789',
	'KBo 32.20': 'CTH 789',
	'KBo 32.209': 'CTH 789',
	'KBo 32.21': 'CTH 789',
	'KBo 32.210': 'CTH 789',
	'KBo 32.212': 'CTH 789',
	'KBo 32.213': 'CTH 789',
	'KBo 32.214': 'CTH 789',
	'KBo 32.215': 'CTH 789',
	'KBo 32.217': 'CTH 789',
	'KBo 32.22': 'CTH 789',
	'KBo 32.23': 'CTH 789',
	'KBo 32.24+': 'CTH 789',
	'KBo 32.25': 'CTH 789',
	'KBo 32.26': 'CTH 789',
	'KBo 32.27': 'CTH 789',
	'KBo 32.28': 'CTH 789',
	'KBo 32.29': 'CTH 789',
	'KBo 32.30': 'CTH 789',
	'KBo 32.31+': 'CTH 789',
	'KBo 32.32': 'CTH 789',
	'KBo 32.33': 'CTH 789',
	'KBo 32.34': 'CTH 789',
	'KBo 32.35': 'CTH 789',
	'KBo 32.36': 'CTH 789',
	'KBo 32.37': 'CTH 789',
	'KBo 32.38': 'CTH 789',
	'KBo 32.39': 'CTH 789',
	'KBo 32.40': 'CTH 789',
	'KBo 32.41': 'CTH 789',
	'KBo 32.42': 'CTH 789',
	'KBo 32.43': 'CTH 789',
	'KBo 32.44': 'CTH 789',
	'KBo 32.45': 'CTH 789',
	'KBo 32.46': 'CTH 789',
	'KBo 32.47a+': 'CTH 789',
	'KBo 32.47b': 'CTH 789',
	'KBo 32.48': 'CTH 789',
	'KBo 32.49': 'CTH 789',
	'KBo 32.50': 'CTH 789',
	'KBo 32.51': 'CTH 789',
	'KBo 32.52': 'CTH 789',
	'KBo 32.53': 'CTH 789',
	'KBo 32.54': 'CTH 789',
	'KBo 32.55': 'CTH 789',
	'KBo 32.56': 'CTH 789',
	'KBo 32.57': 'CTH 789',
	'KBo 32.58': 'CTH 789',
	'KBo 32.59': 'CTH 789',
	'KBo 32.60': 'CTH 789',
	'KBo 32.61': 'CTH 789',
	'KBo 32.62': 'CTH 789',
	'KBo 32.63': 'CTH 789',
	'KBo 32.64': 'CTH 789',
	'KBo 32.66': 'CTH 789',
	'KBo 32.67': 'CTH 789',
	'KBo 32.68': 'CTH 789',
	'KBo 32.69': 'CTH 789',
	'KBo 32.70': 'CTH 789',
	'KBo 32.71': 'CTH 789',
	'KBo 32.72': 'CTH 789',
	'KBo 32.73': 'CTH 789',
	'KBo 32.74': 'CTH 789',
	'KBo 32.75': 'CTH 789',
	'KBo 32.76': 'CTH 789',
	'KBo 32.77': 'CTH 789',
	'KBo 32.78': 'CTH 789',
	'KBo 32.79': 'CTH 789',
	'KBo 32.80': 'CTH 789',
	'KBo 32.81': 'CTH 789',
	'KBo 32.83': 'CTH 789',
	'KBo 32.84': 'CTH 789',
	'KBo 32.85': 'CTH 789',
	'KBo 32.86': 'CTH 789',
	'KBo 32.87': 'CTH 789',
	'KBo 32.88': 'CTH 789',
	'KBo 32.89': 'CTH 789',
	'KBo 32.90a': 'CTH 789',
	'KBo 32.90b': 'CTH 789',
	'KBo 32.91': 'CTH 789',
	'KBo 32.92': 'CTH 789',
	'KBo 32.93': 'CTH 789',
	'KBo 32.94': 'CTH 789',
	'KBo 32.95': 'CTH 789',
	'KBo 32.96': 'CTH 789',
	'KBo 32.97': 'CTH 789',
	'KBo 32.98': 'CTH 789',
	'KBo 32.99': 'CTH 789',
	'RS 19.148': 'CTH 789',
	'ABoT 1.38': 'CTH 790',
	'ABoT 2.248': 'CTH 790',
	'DAAM 1.10': 'CTH 790',
	'DBH 46_2.86': 'CTH 790',
	'DBH 46_2.90': 'CTH 790',
	'HFAC 86': 'CTH 790',
	'IBoT 4.86': 'CTH 790',
	'IBoT 4.89': 'CTH 790',
	'KBo 17.34': 'CTH 790',
	'KBo 17.92': 'CTH 790',
	'KBo 19.149': 'CTH 790',
	'KBo 22.164+': 'CTH 790',
	'KBo 23.100+': 'CTH 790',
	'KBo 23.37': 'CTH 790',
	'KBo 27.117': 'CTH 790',
	'KBo 27.123': 'CTH 790',
	'KBo 27.151': 'CTH 790',
	'KBo 27.164': 'CTH 790',
	'KBo 27.171': 'CTH 790',
	'KBo 27.189': 'CTH 790',
	'KBo 30.183': 'CTH 790',
	'KBo 33.116+': 'CTH 790',
	'KBo 33.122': 'CTH 790',
	'KBo 33.143': 'CTH 790',
	'KBo 33.148': 'CTH 790',
	'KBo 33.149': 'CTH 790',
	'KBo 33.152': 'CTH 790',
	'KBo 33.158': 'CTH 790',
	'KBo 33.217': 'CTH 790',
	'KBo 33.36': 'CTH 790',
	'KBo 33.39': 'CTH 790',
	'KBo 33.54': 'CTH 790',
	'KBo 33.58': 'CTH 790',
	'KBo 33.59': 'CTH 790',
	'KBo 33.75': 'CTH 790',
	'KBo 33.86': 'CTH 790',
	'KBo 33.89': 'CTH 790',
	'KBo 33.94': 'CTH 790',
	'KBo 33.98': 'CTH 790',
	'KBo 35.110': 'CTH 790',
	'KBo 35.111': 'CTH 790',
	'KBo 35.113+': 'CTH 790',
	'KBo 35.116': 'CTH 790',
	'KBo 35.120': 'CTH 790',
	'KBo 35.174': 'CTH 790',
	'KBo 35.178': 'CTH 790',
	'KBo 35.179': 'CTH 790',
	'KBo 35.180': 'CTH 790',
	'KBo 35.181': 'CTH 790',
	'KBo 35.184': 'CTH 790',
	'KBo 35.186': 'CTH 790',
	'KBo 35.187': 'CTH 790',
	'KBo 35.188': 'CTH 790',
	'KBo 35.189': 'CTH 790',
	'KBo 35.54': 'CTH 790',
	'KBo 35.56': 'CTH 790',
	'KBo 35.57': 'CTH 790',
	'KBo 35.59': 'CTH 790',
	'KBo 38.57': 'CTH 790',
	'KBo 40.96': 'CTH 790',
	'KBo 42.11': 'CTH 790',
	'KBo 43.229': 'CTH 790',
	'KBo 43.230': 'CTH 790',
	'KBo 44.195': 'CTH 790',
	'KBo 44.32': 'CTH 790',
	'KBo 45.268': 'CTH 790',
	'KBo 47.137': 'CTH 790',
	'KBo 47.267': 'CTH 790',
	'KBo 48.174': 'CTH 790',
	'KBo 49.24': 'CTH 790',
	'KBo 51.223': 'CTH 790',
	'KBo 51.225': 'CTH 790',
	'KBo 51.226': 'CTH 790',
	'KBo 52.217': 'CTH 790',
	'KBo 52.218': 'CTH 790',
	'KBo 52.219': 'CTH 790',
	'KBo 53.224': 'CTH 790',
	'KBo 54.230': 'CTH 790',
	'KBo 56.201': 'CTH 790',
	'KBo 56.204': 'CTH 790',
	'KBo 57.58': 'CTH 790',
	'KBo 58.229': 'CTH 790',
	'KBo 58.23': 'CTH 790',
	'KBo 58.230': 'CTH 790',
	'KBo 58.231': 'CTH 790',
	'KBo 58.232': 'CTH 790',
	'KBo 59.178': 'CTH 790',
	'KBo 60.221': 'CTH 790',
	'KBo 60.222': 'CTH 790',
	'KBo 60.223': 'CTH 790',
	'KBo 61.238': 'CTH 790',
	'KBo 61.239': 'CTH 790',
	'KBo 61.296': 'CTH 790',
	'KBo 63.129': 'CTH 790',
	'KBo 63.130': 'CTH 790',
	'KBo 63.131': 'CTH 790',
	'KBo 64.188': 'CTH 790',
	'KBo 64.189': 'CTH 790',
	'KBo 64.191': 'CTH 790',
	'KBo 64.192': 'CTH 790',
	'KBo 64.193': 'CTH 790',
	'KBo 64.194': 'CTH 790',
	'KBo 64.47': 'CTH 790',
	'KBo 67.274': 'CTH 790',
	'KBo 67.296': 'CTH 790',
	'KBo 67.54': 'CTH 790',
	'KBo 68.112': 'CTH 790',
	'KBo 8.150': 'CTH 790',
	'KUB 27.17': 'CTH 790',
	'KUB 27.34': 'CTH 790',
	'KUB 27.35': 'CTH 790',
	'KUB 32.41': 'CTH 790',
	'KUB 32.48': 'CTH 790',
	'KUB 32.59': 'CTH 790',
	'KUB 32.62': 'CTH 790',
	'KUB 32.63': 'CTH 790',
	'KUB 32.67': 'CTH 790',
	'KUB 32.71': 'CTH 790',
	'KUB 34.104': 'CTH 790',
	'KUB 34.96': 'CTH 790',
	'KUB 45.10': 'CTH 790',
	'KUB 45.27': 'CTH 790',
	'KUB 45.51': 'CTH 790',
	'KUB 45.54': 'CTH 790',
	'KUB 45.84': 'CTH 790',
	'KUB 45.90': 'CTH 790',
	'KUB 47.27': 'CTH 790',
	'KUB 47.36': 'CTH 790',
	'KUB 47.44': 'CTH 790',
	'KUB 47.49': 'CTH 790',
	'KUB 47.53': 'CTH 790',
	'KUB 47.54': 'CTH 790',
	'KUB 47.58': 'CTH 790',
	'KUB 47.79': 'CTH 790',
	'KUB 52.104': 'CTH 790',
	'KUB 52.109': 'CTH 790',
	'KUB 57.54': 'CTH 790',
	'KUB 58.88+': 'CTH 790',
	'KUB 60.19': 'CTH 790',
	'Or. 90_1609': 'CTH 790',
	'Or. 90_566': 'CTH 790',
	'Or. 97_1': 'CTH 790',
	'Privat 27': 'CTH 790',
	'VSNF 12.77': 'CTH 790',
	'VSNF 12.78': 'CTH 790',
	'ABoT 2.250': 'CTH 791',
	'ABoT 2.251': 'CTH 791',
	'ABoT 2.252': 'CTH 791',
	'CHDS 3.112': 'CTH 791',
	'DAAM 1.11': 'CTH 791',
	'DAAM 1.15': 'CTH 791',
	'DAAM 1.27': 'CTH 791',
	'DAAM 1.28': 'CTH 791',
	'DAAM 1.32': 'CTH 791',
	'Dispersa 2': 'CTH 791',
	'FHL 183': 'CTH 791',
	'FHL 43': 'CTH 791',
	'HFAC 85': 'CTH 791',
	'HFAC 87': 'CTH 791',
	'HFAC 88': 'CTH 791',
	'HFAC 89': 'CTH 791',
	'HFAC 90': 'CTH 791',
	'HHCTO 13': 'CTH 791',
	'HT 43': 'CTH 791',
	'IBoT 2.41': 'CTH 791',
	'IBoT 3.142': 'CTH 791',
	'IBoT 4.241': 'CTH 791',
	'KBo 14.119': 'CTH 791',
	'KBo 14.120': 'CTH 791',
	'KBo 14.134': 'CTH 791',
	'KBo 14.137': 'CTH 791',
	'KBo 19.143': 'CTH 791',
	'KBo 27.104': 'CTH 791',
	'KBo 27.105': 'CTH 791',
	'KBo 27.111': 'CTH 791',
	'KBo 27.115': 'CTH 791',
	'KBo 27.135': 'CTH 791',
	'KBo 27.168': 'CTH 791',
	'KBo 27.169': 'CTH 791',
	'KBo 27.170': 'CTH 791',
	'KBo 27.174': 'CTH 791',
	'KBo 27.181': 'CTH 791',
	'KBo 27.186': 'CTH 791',
	'KBo 33.100': 'CTH 791',
	'KBo 33.101': 'CTH 791',
	'KBo 33.105': 'CTH 791',
	'KBo 33.11': 'CTH 791',
	'KBo 33.128': 'CTH 791',
	'KBo 33.129': 'CTH 791',
	'KBo 33.132': 'CTH 791',
	'KBo 33.138': 'CTH 791',
	'KBo 33.153': 'CTH 791',
	'KBo 33.156': 'CTH 791',
	'KBo 33.199': 'CTH 791',
	'KBo 33.206': 'CTH 791',
	'KBo 33.42': 'CTH 791',
	'KBo 33.44': 'CTH 791',
	'KBo 33.46': 'CTH 791',
	'KBo 33.50': 'CTH 791',
	'KBo 33.53': 'CTH 791',
	'KBo 33.55+': 'CTH 791',
	'KBo 33.56': 'CTH 791',
	'KBo 33.57': 'CTH 791',
	'KBo 33.60': 'CTH 791',
	'KBo 33.65': 'CTH 791',
	'KBo 33.66': 'CTH 791',
	'KBo 33.68': 'CTH 791',
	'KBo 33.69': 'CTH 791',
	'KBo 33.70': 'CTH 791',
	'KBo 33.72': 'CTH 791',
	'KBo 33.74': 'CTH 791',
	'KBo 33.76': 'CTH 791',
	'KBo 33.77': 'CTH 791',
	'KBo 33.78': 'CTH 791',
	'KBo 33.80': 'CTH 791',
	'KBo 33.81': 'CTH 791',
	'KBo 33.82': 'CTH 791',
	'KBo 33.85': 'CTH 791',
	'KBo 33.87': 'CTH 791',
	'KBo 33.90': 'CTH 791',
	'KBo 33.91': 'CTH 791',
	'KBo 33.93': 'CTH 791',
	'KBo 33.95': 'CTH 791',
	'KBo 33.96': 'CTH 791',
	'KBo 35.10+': 'CTH 791',
	'KBo 35.105': 'CTH 791',
	'KBo 35.11': 'CTH 791',
	'KBo 35.115+': 'CTH 791',
	'KBo 35.119': 'CTH 791',
	'KBo 35.12': 'CTH 791',
	'KBo 35.16': 'CTH 791',
	'KBo 35.18': 'CTH 791',
	'KBo 35.190': 'CTH 791',
	'KBo 35.192': 'CTH 791',
	'KBo 35.20': 'CTH 791',
	'KBo 35.23': 'CTH 791',
	'KBo 35.251': 'CTH 791',
	'KBo 35.26': 'CTH 791',
	'KBo 35.27': 'CTH 791',
	'KBo 35.28': 'CTH 791',
	'KBo 35.29': 'CTH 791',
	'KBo 35.30': 'CTH 791',
	'KBo 35.31': 'CTH 791',
	'KBo 35.32': 'CTH 791',
	'KBo 35.33': 'CTH 791',
	'KBo 35.35': 'CTH 791',
	'KBo 35.36': 'CTH 791',
	'KBo 35.37': 'CTH 791',
	'KBo 35.38': 'CTH 791',
	'KBo 35.39': 'CTH 791',
	'KBo 35.42': 'CTH 791',
	'KBo 35.45': 'CTH 791',
	'KBo 35.48': 'CTH 791',
	'KBo 35.49': 'CTH 791',
	'KBo 35.50': 'CTH 791',
	'KBo 35.53': 'CTH 791',
	'KBo 35.61': 'CTH 791',
	'KBo 35.64': 'CTH 791',
	'KBo 35.69': 'CTH 791',
	'KBo 35.8': 'CTH 791',
	'KBo 39.221': 'CTH 791',
	'KBo 39.226': 'CTH 791',
	'KBo 39.282': 'CTH 791',
	'KBo 40.100': 'CTH 791',
	'KBo 40.101': 'CTH 791',
	'KBo 40.98': 'CTH 791',
	'KBo 40.99': 'CTH 791',
	'KBo 42.138': 'CTH 791',
	'KBo 42.139': 'CTH 791',
	'KBo 43.231': 'CTH 791',
	'KBo 43.232': 'CTH 791',
	'KBo 44.198': 'CTH 791',
	'KBo 44.202': 'CTH 791',
	'KBo 46.259': 'CTH 791',
	'KBo 46.260': 'CTH 791',
	'KBo 46.261': 'CTH 791',
	'KBo 46.262': 'CTH 791',
	'KBo 47.132': 'CTH 791',
	'KBo 47.134': 'CTH 791',
	'KBo 47.135': 'CTH 791',
	'KBo 47.151': 'CTH 791',
	'KBo 47.271': 'CTH 791',
	'KBo 47.272': 'CTH 791',
	'KBo 48.179': 'CTH 791',
	'KBo 48.63': 'CTH 791',
	'KBo 49.162': 'CTH 791',
	'KBo 49.178': 'CTH 791',
	'KBo 49.217': 'CTH 791',
	'KBo 49.218': 'CTH 791',
	'KBo 49.30': 'CTH 791',
	'KBo 51.227': 'CTH 791',
	'KBo 51.229': 'CTH 791',
	'KBo 51.231': 'CTH 791',
	'KBo 52.220': 'CTH 791',
	'KBo 52.221': 'CTH 791',
	'KBo 52.222': 'CTH 791',
	'KBo 52.223': 'CTH 791',
	'KBo 54.232': 'CTH 791',
	'KBo 54.233': 'CTH 791',
	'KBo 54.234': 'CTH 791',
	'KBo 54.235': 'CTH 791',
	'KBo 54.236': 'CTH 791',
	'KBo 54.237': 'CTH 791',
	'KBo 54.238': 'CTH 791',
	'KBo 54.239': 'CTH 791',
	'KBo 56.202': 'CTH 791',
	'KBo 56.203': 'CTH 791',
	'KBo 56.205': 'CTH 791',
	'KBo 56.206': 'CTH 791',
	'KBo 57.216': 'CTH 791',
	'KBo 57.217': 'CTH 791',
	'KBo 57.218': 'CTH 791',
	'KBo 57.219': 'CTH 791',
	'KBo 57.220': 'CTH 791',
	'KBo 57.221': 'CTH 791',
	'KBo 58.234': 'CTH 791',
	'KBo 58.235': 'CTH 791',
	'KBo 58.239': 'CTH 791',
	'KBo 58.240': 'CTH 791',
	'KBo 59.179': 'CTH 791',
	'KBo 59.180': 'CTH 791',
	'KBo 59.181': 'CTH 791',
	'KBo 59.182': 'CTH 791',
	'KBo 60.224': 'CTH 791',
	'KBo 60.225': 'CTH 791',
	'KBo 60.227+': 'CTH 791',
	'KBo 60.228': 'CTH 791',
	'KBo 60.229': 'CTH 791',
	'KBo 60.230': 'CTH 791',
	'KBo 60.231': 'CTH 791',
	'KBo 60.233': 'CTH 791',
	'KBo 60.234': 'CTH 791',
	'KBo 61.244': 'CTH 791',
	'KBo 61.245': 'CTH 791',
	'KBo 61.246': 'CTH 791',
	'KBo 64.182': 'CTH 791',
	'KBo 64.196': 'CTH 791',
	'KBo 64.197': 'CTH 791',
	'KBo 64.199': 'CTH 791',
	'KBo 64.200': 'CTH 791',
	'KBo 64.201': 'CTH 791',
	'KBo 64.202': 'CTH 791',
	'KBo 64.203': 'CTH 791',
	'KBo 64.245': 'CTH 791',
	'KBo 64.358': 'CTH 791',
	'KBo 65.143': 'CTH 791',
	'KBo 65.215': 'CTH 791',
	'KBo 67.166': 'CTH 791',
	'KBo 68.113': 'CTH 791',
	'KBo 68.114': 'CTH 791',
	'KBo 68.115': 'CTH 791',
	'KBo 69.137': 'CTH 791',
	'KBo 69.242': 'CTH 791',
	'KBo 71.167': 'CTH 791',
	'KBo 71.209': 'CTH 791',
	'KBo 71.27': 'CTH 791',
	'KBo 71.79': 'CTH 791',
	'KBo 8.138': 'CTH 791',
	'KBo 8.143': 'CTH 791',
	'KBo 8.145': 'CTH 791',
	'KBo 8.147': 'CTH 791',
	'KBo 8.153': 'CTH 791',
	'KUB 27.31a': 'CTH 791',
	'KUB 27.32': 'CTH 791',
	'KUB 27.36': 'CTH 791',
	'KUB 27.41': 'CTH 791',
	'KUB 27.43': 'CTH 791',
	'KUB 27.45': 'CTH 791',
	'KUB 32.27': 'CTH 791',
	'KUB 32.31': 'CTH 791',
	'KUB 32.34': 'CTH 791',
	'KUB 32.39': 'CTH 791',
	'KUB 32.69': 'CTH 791',
	'KUB 45.29': 'CTH 791',
	'KUB 45.68': 'CTH 791',
	'KUB 45.73': 'CTH 791',
	'KUB 45.83': 'CTH 791',
	'KUB 45.85': 'CTH 791',
	'KUB 45.88': 'CTH 791',
	'KUB 45.89': 'CTH 791',
	'KUB 47.100': 'CTH 791',
	'KUB 47.102': 'CTH 791',
	'KUB 47.103': 'CTH 791',
	'KUB 47.104+': 'CTH 791',
	'KUB 47.105': 'CTH 791',
	'KUB 47.106': 'CTH 791',
	'KUB 47.107': 'CTH 791',
	'KUB 47.109': 'CTH 791',
	'KUB 47.110': 'CTH 791',
	'KUB 47.111': 'CTH 791',
	'KUB 47.25': 'CTH 791',
	'KUB 47.29': 'CTH 791',
	'KUB 47.50': 'CTH 791',
	'KUB 47.57': 'CTH 791',
	'KUB 47.60': 'CTH 791',
	'KUB 47.63': 'CTH 791',
	'KUB 47.68': 'CTH 791',
	'KUB 47.76': 'CTH 791',
	'KUB 47.78': 'CTH 791',
	'KUB 47.86': 'CTH 791',
	'KUB 47.99': 'CTH 791',
	'KUB 52.112': 'CTH 791',
	'KUB 60.130+': 'CTH 791',
	'KUB 60.82': 'CTH 791',
	'VBoT 14': 'CTH 791',
	'VBoT 19': 'CTH 791',
	'VBoT 41': 'CTH 791',
	'KBo 33.10 {€1} (+) KBo 19.124 {€2} + KBo 54.5 {€3}': 'CTH 341.II',
	'KBo 51.228 {€3} (+) KUB 8.60 {€1} (+) KUB 47.9 {€2} (+) KBo 68.145 {€4}': 'CTH 341.II',
	'KBo 8.144 {€2} + KBo 6.33 {€1} + KUB 52.111 {€3}': 'CTH 341.II',
	'KBo 33.61a {€2} + KBo 33.61b {€1} + KBo 33.61c {€3}': 'CTH 345.II',
	'KUB 45.64 {€1} + Bo 3294a {€2}': 'CTH 345.II',
	'KBo 12.80 {€2} + KBo 27.180 {€1} + KUB 45.62 {€3}': 'CTH 348.II',
	'KBo 27.219 {€3} + KUB 47.1 {€1} (+) KUB 47.112 {€2} + KBo 61.243 {€4} + KBo 7.70 {€5} + KBo 12.79 {€6} + KBo 27.218 {€7}': 'CTH 361.II',
	'KUB 27.40 {€1} + KUB 36.61 {€2}': 'CTH 361.II',
	'KUB 47.5 {€1} + CHDS 3.118 {€2} + KUB 47.11 {€3} + KUB 47.7 {€4}': 'CTH 361.II',
	'KUB 52.114 {€2} + ABoT 1.36 {€1}': 'CTH 361.II',
	'KBo 27.114 {€2}': 'CTH 370',
	'KBo 35.52 {€1} + KBo 35.44 {€2}': 'CTH 370',
	'KBo 33.51 {€1}': 'CTH 774',
	'KBo 35.24 {€2}': 'CTH 774',
	'KBo 33.202': 'CTH 776',
	'KBo 33.203': 'CTH 776',
	'KBo 33.205+': 'CTH 776',
	'KBo 33.205{€1}': 'CTH 776',
	'KBo 35.183+': 'CTH 776',
	'KBo 35.183{€1}': 'CTH 776',
	'KUB 45.60': 'CTH 776',
	'KUB 47.12': 'CTH 776',
	'KUB 47.17': 'CTH 776',
	'KBo 15.70 {€3}': 'CTH 777',
	'KBo 15.72 {€1}': 'CTH 777',
	'KBo 21.44 {€1}': 'CTH 777',
	'KBo 27.102 {€1}': 'CTH 777',
	'KBo 27.92 {€1}': 'CTH 777',
	'KBo 27.95': 'CTH 777',
	'KBo 33.12 {€1}': 'CTH 777',
	'KBo 33.15 {€1}': 'CTH 777',
	'KBo 33.43 {€2}': 'CTH 777',
	'KBo 40.123 {€2}': 'CTH 777',
	'KUB 32.23 {€3}': 'CTH 777',
	'KUB 32.25 {€3}': 'CTH 777',
	'KUB 32.40 {€1}': 'CTH 777',
	'KUB 32.51 {€2}': 'CTH 777',
	'KBo 32.13 {€1}': 'CTH 789',
	'KBo 32.24 {€1}': 'CTH 789',
	'KBo 32.31 {€1}': 'CTH 789',
	'KBo 32.47a {€1}': 'CTH 789',
	'KBo 33.137 {€1} + KBo 54.231 {€2} + ABoT 2.249 {€3}': 'CTH 776',
	'KBo 51.224 {€1} + KBo 35.41 {€2}': 'CTH 776',
	'KUB 47.12+': 'CTH 776',
	'KUB 47.12{€1} + HT 93{€2}': 'CTH 776'
};

export const textToCthGroup = objectToMap(textToCthGroupObject);
